var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSygnomicsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F9B7BF6A-2415-4450-A747-A24DEB8A1D96") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.027197%",
    y1: "18.2873545%",
    x2: "81.1868536%",
    y2: "81.2815821%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BD63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A36DFF",
    offset: "50.6911058%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0043CD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tools-/-Technology-/-development-/-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,15 L18,18 L15,18 L15,15 L18,15 M13.5,13.5 L13.5,19.5 L19.5,19.5 L19.5,13.5 L13.5,13.5 Z M25.5,17.25 L25.5,20.25 L22.5,20.25 L22.5,17.25 L25.5,17.25 M21,15.75 L21,21.75 L27,21.75 L27,15.75 L21,15.75 Z M18,24 L18,27 L15,27 L15,24 L18,24 M13.5,22.5 L13.5,28.5 L19.5,28.5 L19.5,22.5 L13.5,22.5 Z M28.5,19.5 L28.5,24 L24,24 L24,28.5 L19.5,28.5 L19.5,34.5 L34.5,34.5 L34.5,19.5 L28.5,19.5 Z M25.5,25.5 L28.5,25.5 L28.5,28.5 L25.5,28.5 L25.5,25.5 Z M24,33 L21,33 L21,30 L24,30 L24,33 Z M28.5,33 L25.5,33 L25.5,30 L28.5,30 L28.5,33 Z M33,33 L30,33 L30,30 L33,30 L33,33 Z M33,28.5 L30,28.5 L30,25.5 L33,25.5 L33,28.5 Z M30,24 L30,21 L33,21 L33,24 L30,24 Z",
    id: "Fill",
    fill: "url(#linearGradient-1)",
    transform: "translate(24.000000, 24.000000) rotate(-180.000000) translate(-24.000000, -24.000000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSygnomicsLogo);
export default __webpack_public_path__ + "static/media/sygnomics-logo.53a54e2c.svg";
export { ForwardRef as ReactComponent };